// Device-local recent question history (no sign-in, stored in localStorage).
const KEY = "amd-history";
const MAX = 10;

export function getHistory() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function addHistory(question, category_label = "") {
  const q = (question || "").trim();
  if (!q) return;
  let list = getHistory().filter((h) => h.question.toLowerCase() !== q.toLowerCase());
  list.unshift({ question: q, category_label, ts: Date.now() });
  list = list.slice(0, MAX);
  try {
    localStorage.setItem(KEY, JSON.stringify(list));
  } catch {
    /* ignore */
  }
  return list;
}

export function clearHistory() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
